export default "__VITE_ASSET__Dxe1_giw__"